// extracted by css-extract-rspack-plugin
export default {"notification":"notification-Tgm5cW","error":"error-KdxypJ","show":"show-ERhk_V"};